// <s-sticky-add-to-cart> — mobile bar that keeps add to cart in reach while the product form is off screen. Command: --add.
class SStickyAddToCart extends HTMLElement {
  #ac;
  #observer;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    const form = document.querySelector(this.dataset.formSelector || 's-product-form');
    if (!form) return;

    this.addEventListener('command', (event) => {
      if (event.command === '--add') this.#add(form);
    }, { signal });

    this.#observer = new IntersectionObserver(([entry]) => {
      this.toggleAttribute('data-visible', !entry.isIntersecting);
      this.inert = entry.isIntersecting;
    });
    this.#observer.observe(form);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#observer?.disconnect();
  }

  #add(form) {
    const button = form.querySelector('button[name="add"]');
    if (button && button.getAttribute('aria-disabled') !== 'true') {
      button.click();
      return;
    }
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}

if (!customElements.get('s-sticky-add-to-cart')) customElements.define('s-sticky-add-to-cart', SStickyAddToCart);
